import * as yup from 'yup';

import { AdminSettingsResponse } from '../../../types';

import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';

import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { FormContent } from './components/FormContent';

export const SETTINGS_GROUP_NAME = 'push-notifications';

const schema = yup.object({
  push_appKey: yup.string().default(''),
  push_productKey: yup.string().default(''),
  push_allowedChannels: yup.string().default('')
});

export const PushNotifications = () => {
  const { data: pushNotifications = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(SETTINGS_GROUP_NAME);

  const { isLoading, mutate: save } = useSaveResource({
    url: ADMIN_SETTINGS_GROUP,
    id: pushNotifications[0]?.groupId,
    invalidateQueryKey: [SETTINGS_GROUP_NAME]
  });

  const settings = pushNotifications[0] ?? undefined;

  const onSubmit = (data) => {
    const payload = {
      ...settings,
      settings: transformAdminSettingsToRequestValues(data, settings?.settings)
    };
    save(payload);
  };

  return (
    <AdminSettingsFormWrapper
      submitForm={onSubmit}
      schema={schema}
      isFetching={isFetching}
      isLoading={isLoading}
      data={transformAdminSettingsToFormValues(settings)}
    >
      <FormContent />
    </AdminSettingsFormWrapper>
  );
};
